import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {
  LEAD_CONDITION,
  LEAD_CONDITIONS,
} from '../../../../services/utilityFunctions';

export default function ConditionColumn({ t, condition }) {
  const statusClass = (() => {
    switch (condition) {
      case LEAD_CONDITION.PROPOSAL:
        return 'm-badge--focus';
      case LEAD_CONDITION.NEED_DISCOVERED:
        return 'm-badge--info';
      case LEAD_CONDITION.LEADS:
      default:
        return 'm-badge--success';
    }
  })();

  const badgeClass = cx(
    'challenge-badge',
    'm-badge',
    'm-badge--square',
    statusClass,
  );
  return (
    <div className={badgeClass}>
      {t(`challengeDetails_leadCondition_${condition}`)}
    </div>
  );
}

ConditionColumn.propTypes = {
  t: PropTypes.func.isRequired,
  condition: PropTypes.oneOf(LEAD_CONDITIONS).isRequired,
};
